'use client';

import React from 'react';
import Icon from '../Icon/Icon';

const Input = ({
  value,
  iconBefore,
  clearInput,
  onClear,
  error,
  info,
  ...props
}: InputProps): JSX.Element => {
  return (
    <div className="my-2">
      <div className="relative">
        {iconBefore ? (
          <div className="absolute top-1/2 -translate-y-1/2 left-3">
            <Icon name={iconBefore} />
          </div>
        ) : (
          ''
        )}
        <input
          onWheel={(e): void => e.currentTarget.blur()}
          className={`py-1.5 px-4 text-lg border w-full rounded-md  remove-arrow focus:outline-none focus:ring-2 focus:ring-outline-primary-muted ${
            error
              ? 'text-negative-normal border-negative-normal pr-8'
              : 'border-outline-grey-subtle focus:border-neutral-1300'
          }
          ${iconBefore ? `pl-9` : `pl-4`} ${clearInput ? `pr-9` : `pr-4`}`}
          value={value}
          {...props}
        />
        {error ? <Icon name="error" className="absolute right-3 top-0 my-auto bottom-0" /> : null}
        {clearInput ? (
          <div
            aria-hidden
            onClick={onClear}
            className="absolute right-3  -translate-y-1/2 top-1/2 cursor-pointer"
          >
            &times;
          </div>
        ) : (
          ''
        )}
      </div>
      {info && !error ? (
        <span className="mt-1.5 text-black-subtle text-sm flex items-center gap-1">
          <Icon name="error" fill="#000000B8" /> {info}
        </span>
      ) : null}
      {error ? (
        <span className="mt-1.5 text-negative-normal text-sm flex items-center gap-1">
          <Icon name="error" /> {error}
        </span>
      ) : null}
    </div>
  );
};

export default Input;
